import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest } from 'utils/api'
import { getClientId } from 'utils/utils'

export const GET_PLANNED_WORK_COUNT = 'GET_PLANNED_WORK_COUNT'
export const getPlannedWorkCount = (search) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_PLANNED_WORK_COUNT)())
    const clientId = getClientId(getState)
    const options = {
      where: {
        and: [
          { clientId }
        ]
      }
    }
    if (search) {
      options.where.and.push(search)
    }
    sendApiRequest('PlannedWorks/count', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getPlannedWorkCountError(response))
      }
      if (response.status === 'success') {
        dispatch(getPlannedWorkCountSuccess(response.data.count))
      }
    })
  }
}

export const GET_PLANNED_WORK_COUNT_SUCCESS = 'GET_PLANNED_WORK_COUNT_SUCCESS'
export const getPlannedWorkCountSuccess = createAction(GET_PLANNED_WORK_COUNT_SUCCESS)

export const GET_PLANNED_WORK_COUNT_ERROR = 'GET_PLANNED_WORK_COUNT_ERROR'
export const getPlannedWorkCountError = createAction(GET_PLANNED_WORK_COUNT_ERROR)

export const GET_PLANNED_WORKS = 'GET_PLANNED_WORKS'
export const getPlannedWorks = (pageSize, pageNumber, search) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_PLANNED_WORKS)())
    const clientId = getClientId(getState)
    const options = {
      filter: {
        order: 'npwId DESC',
        limit: pageSize,
        where: {
          and: [
            { clientId }
          ]
        }
      }
    }
    if (pageNumber !== 1) {
      options.filter.skip = (pageNumber - 1) * pageSize
    }
    if (search) {
      options.filter.where.and.push(search)
    }
    sendApiRequest('PlannedWorks', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getPlannedWorksError(response))
      }
      if (response.status === 'success') {
        dispatch(getPlannedWorksSuccess(response.data))
      }
    })
  }
}

export const GET_PLANNED_WORKS_SUCCESS = 'GET_PLANNED_WORKS_SUCCESS'
export const getPlannedWorksSuccess = createAction(GET_PLANNED_WORKS_SUCCESS)

export const GET_PLANNED_WORKS_ERROR = 'GET_PLANNED_WORKS_ERROR'
export const getPlannedWorksError = createAction(GET_PLANNED_WORKS_ERROR)

export const GET_PLANNED_WORK_BY_ID = 'GET_PLANNED_WORK_BY_ID'
export const getPlannedWorkById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_PLANNED_WORK_BY_ID)())
    sendApiRequest(`PlannedWorks/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'get').then((response) => {
      if (response.status === 'failure') {
        dispatch(getPlannedWorkByIdError(response))
      }
      if (response.status === 'success') {
        dispatch(getPlannedWorkByIdSuccess(response.data))
      }
    })
  }
}

export const GET_PLANNED_WORK_BY_ID_SUCCESS = 'GET_PLANNED_WORK_BY_ID_SUCCESS'
export const getPlannedWorkByIdSuccess = createAction(GET_PLANNED_WORK_BY_ID_SUCCESS)

export const GET_PLANNED_WORK_BY_ID_ERROR = 'GET_PLANNED_WORK_BY_ID_ERROR'
export const getPlannedWorkByIdError = createAction(GET_PLANNED_WORK_BY_ID_ERROR)

export const GET_PLANNED_WORK_BY_ID_RESET = 'GET_PLANNED_WORK_BY_ID_RESET'
export const getPlannedWorkByIdReset = createAction(GET_PLANNED_WORK_BY_ID_RESET)

export const DELETE_PLANNED_WORK_BY_ID = 'DELETE_PLANNED_WORK_BY_ID'
export const deletePlannedWorkById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(DELETE_PLANNED_WORK_BY_ID)())
    sendApiRequest(`PlannedWorks/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'delete').then((response) => {
      if (response.status === 'failure') {
        dispatch(deletePlannedWorkByIdError(response.data))
      }
      if (response.status === 'success') {
        dispatch(deletePlannedWorkByIdSuccess(response.data))
      }
    })
  }
}

export const DELETE_PLANNED_WORK_BY_ID_SUCCESS = 'DELETE_PLANNED_WORK_BY_ID_SUCCESS'
export const deletePlannedWorkByIdSuccess = createAction(DELETE_PLANNED_WORK_BY_ID_SUCCESS)

export const DELETE_PLANNED_WORK_BY_ID_ERROR = 'DELETE_PLANNED_WORK_BY_ID_ERROR'
export const deletePlannedWorkByIdError = createAction(DELETE_PLANNED_WORK_BY_ID_ERROR)

export const DELETE_PLANNED_WORK_BY_ID_RESET = 'DELETE_PLANNED_WORK_BY_ID_RESET'
export const deletePlannedWorkByIdReset = createAction(DELETE_PLANNED_WORK_BY_ID_RESET)

export const BULK_CREATE_PLANNED_WORK = 'BULK_CREATE_PLANNED_WORK'
export const bulkCreatePlannedWork = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(BULK_CREATE_PLANNED_WORK))
    const clientId = getClientId(getState)
    const options = {
      accessToken: getState().auth.account.accessToken,
      clientId
    }
    const npwData = []
    data.forEach((item) => {
      let jobReqDate = ''
      let jobAppDate = ''
      let jobStartDate = ''
      let jobEndDate = ''
      if (item['DATE REQUESTED']) {
        jobReqDate = new Date(item['DATE REQUESTED'].replace(/(\d+)(st|nd|rd|th)/, '$1'))
      }
      if (item['DATE APPROVED']) {
        jobAppDate = new Date(item['DATE APPROVED'].replace(/(\d+)(st|nd|rd|th)/, '$1'))
      }
      if (item['ACTUAL START DATE']) {
        jobStartDate = new Date((item['ACTUAL START DATE'].replace(/(\d+)(st|nd|rd|th)/, '$1')))
      }
      if (item['ACTUAL FINISH DATE']) {
        jobEndDate = new Date(item['ACTUAL FINISH DATE'].replace(/(\d+)(st|nd|rd|th)/, '$1'))
      }
      const filteredItem = {
        clientId,
        // accessToken: getState().auth.account.accessToken,
        jobNo: item['JOB. NO.'],
        jobType: item.TYPE,
        jobAdd: item.LOCATION,
        jobReqDate: jobReqDate.toString(),
        jobAppDate: jobAppDate.toString(),
        jobStartDate: jobStartDate.toString(),
        jobEndDate: jobEndDate.toString(),
        jobDesc: item['BRIEF WORK DESCRIPTION']
      }
      npwData.push(filteredItem)
    })
    sendApiRequest('PlannedWorks', npwData, 'post', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(bulkCreatePlannedWorkError(response.data))
      }
      if (response.status === 'success') {
        dispatch(bulkCreatePlannedWorkSuccess(response.data))
      }
    })
  }
}

export const BULK_CREATE_PLANNED_WORK_SUCCESS = 'BULK_CREATE_PLANNED_WORK_SUCCESS'
export const bulkCreatePlannedWorkSuccess = createAction(BULK_CREATE_PLANNED_WORK_SUCCESS)

export const BULK_CREATE_PLANNED_WORK_ERROR = 'BULK_CREATE_PLANNED_WORK_ERROR'
export const bulkCreatePlannedWorkError = createAction(BULK_CREATE_PLANNED_WORK_ERROR)

const initialState = {
  plannedWorkCount: 0,
  isGettingPlannedWorks: false,
  hasGottenPlannedWorks: false,
  getPlannedWorksError: {},
  plannedWorks: [],
  selectedPlannedWork: {},
  isGettingPlannedWork: false,
  hasGottenPlannedWork: false,
  getPlannedWorkError: {},
  isDeletingPlannedWork: false,
  hasDeletedPlannedWork: false,
  deletePlannedWorkSuccess: {},
  deletePlannedWorkError: {},
  isCreatingPlannedWorks: false,
  hasCreatedPlannedWorks: false,
  createPlannedWorksError: [],
  createPlannedWorksSuccess: []
}

export default handleActions({

  [GET_PLANNED_WORK_COUNT_SUCCESS]: (state, { payload }) => ({
    ...state,
    plannedWorkCount: payload
  }),

  [GET_PLANNED_WORKS]: (state) => ({
    ...state,
    isGettingPlannedWorks: true,
    hasGottenPlannedWorks: false
  }),

  [GET_PLANNED_WORKS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingPlannedWorks: false,
      hasGottenPlannedWorks: true,
      plannedWorks: payload
    }
  },

  [GET_PLANNED_WORKS_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingPlannedWorks: false,
      hasGottenPlannedWorks: false,
      plannedWorksError: payload
    }
  },

  [GET_PLANNED_WORK_BY_ID]: (state) => ({
    ...state,
    isGettingPlannedWork: true,
    hasGottenPlannedWork: false
  }),

  [GET_PLANNED_WORK_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingPlannedWork: false,
      hasGottenPlannedWork: true,
      selectedPlannedWork: payload
    }
  },

  [GET_PLANNED_WORK_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingPlannedWork: false,
      hasGottenPlannedWork: false,
      getPlannedWorkError: payload
    }
  },
  [GET_PLANNED_WORK_BY_ID_RESET]: (state) => ({
    ...state,
    isGettingPlannedWork: false,
    hasGottenPlannedWork: false,
    selectedPlannedWork: {}
  }),

  [DELETE_PLANNED_WORK_BY_ID]: (state) => ({
    ...state,
    isDeletingPlannedWork: true,
    hasDeletedPlannedWork: false
  }),

  [DELETE_PLANNED_WORK_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isDeletingPlannedWork: false,
      hasDeletedPlannedWork: true,
      deletePlannedWorkSuccess: payload
    }
  },

  [DELETE_PLANNED_WORK_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isDeletingPlannedWork: false,
      hasDeletedPlannedWork: false,
      deletePlannedWorkError: payload
    }
  },

  [DELETE_PLANNED_WORK_BY_ID_RESET]: (state) => {
    return {
      ...state,
      isDeletingPlannedWork: false,
      hasDeletedPlannedWork: false,
      deletePlannedWorkError: {},
      deletePlannedWorkSuccess: {}
    }
  },

  [BULK_CREATE_PLANNED_WORK]: (state) => {
    return {
      ...state,
      isCreatingPlannedWorks: true,
      hasCreatedPlannedWorks: false,
      createPlannedWorksError: [],
      createPlannedWorksSuccess: []
    }
  },

  [BULK_CREATE_PLANNED_WORK_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isCreatingPlannedWorks: false,
      hasCreatedPlannedWorks: true,
      createPlannedWorksError: [],
      createPlannedWorksSuccess: payload
    }
  },

  [BULK_CREATE_PLANNED_WORK_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isCreatingPlannedWorks: false,
      hasCreatedPlannedWorks: false,
      createPlannedWorksError: payload,
      createPlannedWorksSuccess: []
    }
  }

}, initialState)
